import React, { useEffect, useMemo, useState } from "react";
import { toHashPath } from "../routes/hashRouting";

function NavLink({ href, active, children, onNavigate }) {
  return (
    <a
      className={active ? "nav-link nav-link-active" : "nav-link"}
      href={href}
      onClick={() => onNavigate?.()}
    >
      {children}
    </a>
  );
}

export default function Header({ routeName }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    if (!mobileOpen) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") setMobileOpen(false);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [mobileOpen]);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileOpen(false);
  }, [routeName]);

  const links = useMemo(
    () => [
      { label: "Home", href: toHashPath("/home"), route: "home" },
      { label: "How to Use", href: toHashPath("/home/howto"), route: "home" },
      { label: "Guides", href: toHashPath("/guides"), route: "guides" },
      { label: "Tools", href: toHashPath("/tools"), route: "tools" },
      { label: "Updates", href: toHashPath("/updates"), route: "updates" },
      { label: "FAQ", href: toHashPath("/home/faq"), route: "home" },
    ],
    []
  );

  return (
    <header className="site-header">
      <div className="container header-inner">
        <a className="brand" href={toHashPath("/home")} aria-label="Calculateyourtax.in — Home">
          <div className="brand-logo" aria-hidden="true">₹</div>
          <div className="brand-text">
            <span className="brand-name">
              Calculate<span>yourtax</span>.in
            </span>
            <span className="brand-tagline">Free India Tax Calculator</span>
          </div>
        </a>

        <nav className="nav-desktop" aria-label="Primary navigation">
          {links.map((l) => (
            <NavLink
              key={l.label}
              href={l.href}
              active={routeName === l.route && l.route !== "home"}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          className="nav-toggle"
          aria-label={mobileOpen ? "Close menu" : "Open menu"}
          aria-expanded={mobileOpen ? "true" : "false"}
          onClick={() => setMobileOpen((v) => !v)}
        >
          <span className="nav-toggle-bar" />
          <span className="nav-toggle-bar" />
          <span className="nav-toggle-bar" />
        </button>
      </div>

      {mobileOpen && (
        <nav className="nav-mobile" role="navigation" aria-label="Mobile menu">
          <div className="container nav-mobile-inner">
            {links.map((l) => (
              <NavLink
                key={l.label}
                href={l.href}
                active={routeName === l.route}
                onNavigate={() => setMobileOpen(false)}
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}
